<template>
    <div class="brt-map-activeModule" ref="activeModule">
        <!--<div class="box"><img src="../../../../../../public/images/activity.png"></div>-->
        <div class="active-enter-module iconfont icon-huodong"></div>
    </div>
</template>

<script>
    export default {
        name: "ActiveModule"
    }
</script>

<style lang="less">
    @import "../../../../../styles/cssBlock.less";
    .brt-map-activeModule{

        //padding-left: @standartSpaceA5;
       // margin-bottom: @standartSpaceA1;
        position: fixed;
        top: @standartHeightA4 + @standartSpaceA5;
        left: @standartSpaceA5;


        @height:@standartHeightA4;
        @space:@standartSpaceA4;

        >.active-enter-module{
            width: @height;
            height: @height;
            line-height: @height;
            text-align: center;

            pointer-events: auto;

            margin-top: @space;

            border-radius: @height/2;

            background-color: rgba(223,132,133,1);

            font-size: @fontSizeA2;
            color: @themeReverseColor;

            box-shadow: @shadowbox;

            &:active{
                opacity: .8;
            }

        }

        /*
        >.box{
            width: @standartWidthA1;
            text-align: center;
            pointer-events:auto;
            >img{width: 90%}

            &:active{opacity: .8}
        }

         */
    }
</style>
